// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"40":"add","177":"home","497":"single"}[chunkId] || chunkId) + "." + {"40":"9ec87bae","177":"70c4f56d","497":"a0402390","574":"98e5408f"}[chunkId] + ".js";
};